import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Pencil, Star, Trash2 } from 'lucide-react';
import { klarysUrl } from './klarysApi';

export const useFavoris = (headers) => {
  const [items, setItems] = useState([]);
  const charger = useCallback(() => axios.get(klarysUrl('/favoris'), { headers }).then((r) => setItems(r.data.items)).catch(() => {}), []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { charger(); }, [charger]);
  const ajouter = async (texte) => {
    try { await axios.post(klarysUrl('/favoris'), { texte }, { headers }); toast.success('Ajoutée aux favoris'); charger(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Ajout impossible'); }
  };
  const retirer = async (id) => {
    try { await axios.delete(klarysUrl(`/favoris/${id}`), { headers }); charger(); } catch (e) { toast.error('Suppression impossible'); }
  };
  const renommer = async (f) => {
    const titre = window.prompt('Nom du favori', f.titre);
    if (!titre || titre === f.titre) return;
    try { await axios.patch(klarysUrl(`/favoris/${f.id}`), { titre }, { headers }); charger(); } catch (e) { toast.error(e.response?.data?.detail || 'Renommage impossible'); }
  };
  const estFavori = (texte) => items.some((f) => f.texte === texte.trim());
  return { items, charger, ajouter, retirer, renommer, estFavori };
};

export const KlarysFavorisBar = ({ fav, onLancer, disabled }) => {
  const [gerer, setGerer] = useState(false);
  if (!fav.items.length) return null;
  return (
    <div className="mb-2 flex flex-wrap items-center gap-1.5" data-testid="klarys-favoris">
      <Star className="h-3.5 w-3.5 text-amber-500" />
      {fav.items.map((f, i) => (
        <span key={f.id} className="inline-flex items-center rounded-full border border-amber-200 bg-amber-50 text-[11px] text-amber-900">
          <button type="button" disabled={disabled} onClick={() => onLancer(f.texte)} title={f.texte} data-testid={`klarys-favori-${i}`}
            className="max-w-[180px] truncate px-2.5 py-1 hover:text-[#0a3d62] disabled:opacity-50">
            <span className="font-semibold">{i + 1}.</span> {f.titre}
          </button>
          {gerer && (
            <>
              <button type="button" onClick={() => fav.renommer(f)} aria-label="Renommer" data-testid={`klarys-favori-renommer-${i}`} className="px-1 hover:text-[#0a3d62]"><Pencil className="h-3 w-3" /></button>
              <button type="button" onClick={() => fav.retirer(f.id)} aria-label="Supprimer" data-testid={`klarys-favori-supprimer-${i}`} className="pr-2 pl-1 hover:text-rose-600"><Trash2 className="h-3 w-3" /></button>
            </>
          )}
        </span>
      ))}
      <button type="button" onClick={() => setGerer((g) => !g)} data-testid="klarys-favoris-gerer" className="text-[10px] text-slate-500 underline hover:text-slate-800">
        {gerer ? 'Terminer' : 'Gérer'}
      </button>
    </div>
  );
};
